var map = {
	"./2nd-chance.svg": 225,
	"./counterattack.svg": 226,
	"./equality.svg": 227,
	"./exchange.svg": 228,
	"./fantastic-four.svg": 229,
	"./fantastic.svg": 230,
	"./fuck-you.svg": 231,
	"./gift.svg": 232,
	"./nice-try.svg": 233,
	"./skip.svg": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;